import { render, staticRenderFns } from "./StyledText.vue?vue&type=template&id=00183960&scoped=true&"
import script from "./StyledText.vue?vue&type=script&lang=ts&"
export * from "./StyledText.vue?vue&type=script&lang=ts&"
import style0 from "./StyledText.vue?vue&type=style&index=0&id=00183960&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00183960",
  null
  
)

export default component.exports